import { DefaultService } from '@/services/DefaultService';

export default class AtendimentoAgricolaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(obj) {
        return this._http.post(`${this._env}/agro/agroservice`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/agroservice/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    finalize(id) {
        return this._http.get(`${this._env}/agro/agroservice/${id}/finalize`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/agro/agroservice/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(filtros, column = 'datahora', order = 'desc', page = 0, limit = 50, ...params) {
        return this._http.post(encodeURI(`${this._env}/agro/agroservice.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    uploadAttachment(idatendimento, form) {
        return this._http.post(`${this._env}/agro/agroservice/${idatendimento}/attachment`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    listAttachments(id, column = 'datahora', order = 'desc', page = 0, limit = 20) {
        return this._http.get(`${this._env}/agro/agroservice/${id}/attachments.json?page=${page}&limit=${limit}&column=${column}&order=${order}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}